// extracted by mini-css-extract-plugin
export default {"chains":"ChainsSelect_chains__IYXSe","chain":"ChainsSelect_chain__JTLFW"};